/* Apeiro Blog Content Sanitizer v3 */
document.addEventListener('DOMContentLoaded', function() {
  var body = document.getElementById('apeiro-article-body');
  var tocList = document.getElementById('apeiro-toc-list');
  var tocWrap = document.getElementById('apeiro-toc');
  if (!body) return;

  /* 1. Convert H1 inside body to H2 */
  body.querySelectorAll('h1').forEach(function(h1) {
    var imgs = h1.querySelectorAll('img');
    if (imgs.length > 0 && !h1.textContent.trim()) {
      var wrapper = document.createElement('div');
      wrapper.style.margin = '2.5rem 0';
      while (h1.firstChild) wrapper.appendChild(h1.firstChild);
      h1.parentNode.replaceChild(wrapper, h1);
    } else {
      var h2 = document.createElement('h2');
      h2.innerHTML = h1.innerHTML;
      h1.parentNode.replaceChild(h2, h1);
    }
  });

  /* 2. Remove empty paragraphs */
  body.querySelectorAll('p').forEach(function(p) {
    if (!p.textContent.trim() && !p.querySelector('img,iframe')) {
      var inner = p.innerHTML.replace(/<br\s*\/?>/gi,'').replace(/<\/?(b|i|em|strong|span)\s*>/gi,'').trim();
      if (!inner) p.remove();
    }
  });

  /* 3. Remove Google Docs artifacts */
  body.querySelectorAll('[dir]').forEach(function(e){e.removeAttribute('dir');});
  body.querySelectorAll('[aria-level]').forEach(function(e){e.removeAttribute('aria-level');});
  body.querySelectorAll('[role="presentation"]').forEach(function(e){e.removeAttribute('role');});
  body.querySelectorAll('[id*="docs-internal-guid"]').forEach(function(e){e.removeAttribute('id');});

  /* 4. Remove empty spans */
  body.querySelectorAll('span').forEach(function(s) {
    if (!s.textContent.trim() && !s.querySelector('img')) s.remove();
  });

  /* 5. Remove inline styles (keep on images/image wrappers/captions) */
  body.querySelectorAll('[style]').forEach(function(el) {
    if (el.tagName==='IMG') return;
    if (el.tagName==='DIV' && el.querySelector('img')) return;
    var st = el.getAttribute('style');
    if (st && st.indexOf('text-align: center')>-1 && el.textContent.trim().length<100) return;
    el.removeAttribute('style');
  });

  /* 6. Unwrap nested spans */
  body.querySelectorAll('p > span, li > span, h2 > span, h3 > span').forEach(function(s) {
    if (!s.className && !s.id && !s.getAttribute('style')) {
      while (s.firstChild) s.parentNode.insertBefore(s.firstChild, s);
      s.remove();
    }
  });

  /* 7. Remove p wrappers inside li */
  body.querySelectorAll('li > p').forEach(function(p) {
    var li = p.parentNode;
    while (p.firstChild) li.insertBefore(p.firstChild, p);
    p.remove();
  });

  /* 8. Restructure FAQ section into accordion */
  var faqH2 = null;
  body.querySelectorAll('h2').forEach(function(h2) {
    var t = h2.textContent.trim().toLowerCase();
    if (t.indexOf('frequently asked')>-1 || t==='faq' || t==='faqs') faqH2 = h2;
  });
  if (faqH2) {
    var faqWrap = document.createElement('div');
    faqWrap.className = 'apeiro-faq-section';
    faqH2.parentNode.insertBefore(faqWrap, faqH2.nextSibling);
    var sib = faqWrap.nextSibling;
    while (sib) {
      var nxt = sib.nextSibling;
      if (sib.nodeType===1 && (sib.tagName==='H2' || sib.tagName==='H1')) break;
      if (sib.nodeType===1) faqWrap.appendChild(sib);
      sib = nxt;
    }
    faqWrap.querySelectorAll('p').forEach(function(p) {
      var bold = p.querySelector('strong, b');
      if (bold && (bold===p.firstElementChild || bold===p.firstChild) && bold.textContent.trim().length>5) {
        var det = document.createElement('details');
        det.className = 'apeiro-faq-item';
        var sum = document.createElement('summary');
        sum.className = 'apeiro-faq-q';
        sum.textContent = bold.textContent.trim();
        det.appendChild(sum);
        var ans = document.createElement('div');
        ans.className = 'apeiro-faq-a';
        ans.textContent = p.textContent.replace(bold.textContent,'').trim();
        det.appendChild(ans);
        p.parentNode.replaceChild(det, p);
      }
    });
  }

  /* 9. Style CTA link paragraphs */
  body.querySelectorAll('p').forEach(function(p) {
    var t = p.textContent.trim();
    if (t==='\u2192' || t==='->') { p.remove(); return; }
    var link = p.querySelector('a');
    if (link && p.childElementCount<=3 && t.length<80) {
      if (t.indexOf('\u2192')>-1) {
        p.textContent='';
        p.appendChild(link);
      }
      if (link===p.firstElementChild && !p.textContent.replace(link.textContent,'').trim()) {
        p.className = (p.className||'') + ' apeiro-cta-link';
      }
    }
  });

  /* 10. Table of Contents */
  if (tocList && tocWrap) {
    var headings = body.querySelectorAll('h2');
    if (headings.length < 2) {
      tocWrap.style.display = 'none';
    } else {
      headings.forEach(function(h, i) {
        var id = 'section-' + (i + 1);
        h.setAttribute('id', id);
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + id;
        a.textContent = h.textContent;
        li.appendChild(a);
        tocList.appendChild(li);
      });
    }
  }
});
